import { useQuery } from '@tanstack/react-query'
import { useCurrentUser, useAccessToken } from '@/features/auth/state/auth'

import api from '@/lib/api'

export function useFetchAnexosByID(id_calculo: string, id_apuracao: string) {
  const user = useCurrentUser()
  const token = useAccessToken()

  return useQuery({
    queryKey: ['anexos', id_calculo, id_apuracao],
    queryFn: async () => {
      if (!user || !token) throw new Error('Usuário ou token ausente')

      const response = await api.get(`/anexos/${id_calculo}/${id_apuracao}`)

      if (response.data) {
        return response.data
      } else {
        throw new Error('Estrutura de resposta inesperada')
      }
    },
    enabled: Boolean(user && token && id_calculo && id_apuracao)
  })
}
